<template>
  <div>
    <v-flex
      v-for="field in attendeeFields"
      :key="field.key"
    >
      <component
        :is="field.component"
        v-if="field.id !== 'Attendee name'"
        v-model="form[field.key.split(' ').join('_')]"
        type="text"
        v-bind="field"
      />
    </v-flex>
    <v-flex
      v-if="extraModules.categoriesAndZones"
      class="pb-16"
    >
      <select-field
        v-model="form['category']"
        :items="workflowUi(categories)"
        :label="adminText('workflowsAll.category_a3c686e', 'Category')"
        item-render="name"
        item-select="id"
      />
    </v-flex>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
const countries = require('../../../assets/countries')

export default {
  mixins: [WorkflowDisplay],
  name: 'filters-modal-form',
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    attendeeFields: {
      type: Array,
      default: () => [],
    },
    extraModules: {
      type: Object,
      default: () => {},
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: { ...this.initialValues },
      countries,
    }
  },
  watch: {
    form: {
      handler(val){
        this.$emit('values', val)
      },
      deep: true,
    },
  },
}

</script>

<style scoped>
</style>
